import type { GlobalConfig } from "./DefaultGlobals";
import { DefaultGlobals } from "./DefaultGlobals";

const USGlobals: GlobalConfig = {
  ...DefaultGlobals,
  country: "United States",
};

export { USGlobals };
